import React, { FC, useEffect, useState } from 'react'
import './PensionUpdate.scss'

import { useForm } from 'react-hook-form'

import { yupResolver } from '@hookform/resolvers/yup'
import * as yup from 'yup'
import { ShowTGAlert } from 'Helpers/ShowTGAlert'
import Swal from 'sweetalert2'
import profileService from 'Services/profileService'

export const PFAS = [
  { code: 'stanbic-ibtc', name: 'Stanbic IBTC Pension Managers' },
  { code: 'trustfund', name: 'Trustfund Pensions Plc' },
  { code: 'premium', name: 'Premium Pension Limited' },
  { code: 'arm', name: 'ARM Pension Managers' },
  { code: 'axamansard', name: 'AXA Mansard Pensions' },
  { code: 'leadway', name: 'Leadway Pensure PFA Limited' },
  { code: 'npf', name: 'NPF Pensions Limited' },
  { code: 'igt', name: 'IGT Pensions' },
  { code: 'pal', name: 'Pensions Alliance Limited' },
  { code: 'radix', name: 'Radix Pension Managers' },
  { code: 'fcmb', name: 'FCMB Pensions Limited' },
  { code: 'firstguarantee', name: 'First Guarantee Pension Limited' },
  { code: 'veritas', name: 'Veritas Glanvills Pensions' },
  { code: 'sigma', name: 'Sigma Pensions Limited' },
  { code: 'crusader', name: 'CrusaderSterling Pensions Limited' },
  { code: 'nlpc', name: 'NLPC Pension Fund Administrators' },
  { code: 'apt', name: 'APT Pensions Fund Managers' },
  { code: 'sage', name: 'Sage Pensions Limited' },
  { code: 'aiico', name: 'AIICO Pension Managers' },
  { code: 'oasis', name: 'Oasis Pensions Limited' },
]

interface propsType {
  toggleModal: () => void
  profile: any
  setProfile: any
}

export type pensionUpdate = {
  pfa: string
  rsaNumber: string
}

const schema = yup.object().shape({
  pfa: yup.string().required('Field is required'),
  rsaNumber: yup.string().required('Field is required'),
})

const PensionUpdate: FC<propsType> = ({ profile, setProfile, toggleModal }) => {
  const {
    handleSubmit,
    register,
    reset,
    formState: { errors },
  } = useForm<pensionUpdate>({
    resolver: yupResolver(schema),
  })

  const { showAlert } = ShowTGAlert()
  const [request, setRequest] = useState(false)

  useEffect(() => {
    if (profile) {
      reset({
        pfa: profile?.pfa === null || profile?.pfa === 'string' ? '' : profile?.pfa,
        rsaNumber:
          profile?.rsaNumber === null || profile?.rsaNumber === 'string' ? '' : profile?.rsaNumber,
      })
    }
  }, [profile, reset])

  const submitNewUserInformation = handleSubmit(async (data: pensionUpdate) => {
    await profileService
      .updateProfileV2({
        pfa: data.pfa,
        rsaNumber: data.rsaNumber,
      })
      .then(
        (res: any) => {
          setRequest(false)
          Swal.fire({
            text: 'Employment information update request sent succesfully',
            icon: 'success',
            confirmButtonText: 'Ok',
          })
          if (res.data.status === true) {
            setProfile((prev: any) => ({
              ...prev,
              ...data,
            }))
          } else {
            const swalWithBootstrapButtons = Swal.mixin({
              customClass: {
                cancelButton: 'btn btn-danger',
              },
              buttonsStyling: false,
            })

            swalWithBootstrapButtons.fire({
              title: 'Oops!',
              text: 'Something went wrong!',
              icon: 'warning',
              showCancelButton: true,
              showConfirmButton: false,
              cancelButtonText: 'close',
              reverseButtons: true,
            })
          }

          toggleModal()
        },
        (error: { response: { data: { error: string } } }) => {
          console.log(error)
          setRequest(false)
          const swalWithBootstrapButtons = Swal.mixin({
            customClass: {
              cancelButton: 'btn btn-danger',
            },
            buttonsStyling: false,
          })

          swalWithBootstrapButtons.fire({
            title: 'Oops!',
            text: error.response.data.error,
            icon: 'warning',
            showCancelButton: true,
            showConfirmButton: false,
            cancelButtonText: 'close',
            reverseButtons: true,
          })
        },
      )
  })
  return (
    <div className='pension-update'>
      <form action='/product-scanner'>
        <div className='form-group mb-3'>
          <label htmlFor='pfa'>PFA</label>

          <select id='pfa' className='form-control' defaultValue='' {...register('pfa')}>
            <option disabled value=''>
              --Select PFA--
            </option>

            {PFAS.map((pfa) => (
              <option key={pfa.code} value={pfa.code}>
                {pfa.name}
              </option>
            ))}
          </select>

          {errors.pfa && <div className='text-danger'>{errors.pfa.message}</div>}
        </div>

        <div className='form-group mb-3'>
          <label htmlFor='price-per-lit'>RSA Number</label>
          <input
            placeholder='RSA Number'
            type='text'
            id='rsaNumber'
            className='form-control'
            {...register('rsaNumber')}
          />
          {errors.rsaNumber && <div className='text-danger'>{errors.rsaNumber.message}</div>}
        </div>

        <div className='form-group'>
          <button
            className='btn btn-default-2 w-100'
            onClick={(e) => submitNewUserInformation(e)}
            disabled={request}
          >
            Save Details {request && <span className='spinner-border spinner-border-sm'></span>}
          </button>
        </div>
      </form>
    </div>
  )
}

export default PensionUpdate
